window.addEventListener("DOMContentLoaded", () => {

    // Hamburger

    if (document.querySelector('nav.mobile')) {
        document.querySelector('nav.main .hamburger').addEventListener('click', function() {
            document.querySelector('nav.mobile').classList.toggle('open');
        })
    
        document.querySelector('nav.mobile .close').addEventListener('click', function() {
            document.querySelector('nav.mobile').classList.toggle('open');
        })
    }

    // Video

    let videos = document.querySelectorAll('video');
    let playBtns = document.querySelectorAll('.video .play');
    if (videos) {

        for (let i = 0 ; i < playBtns.length ; i++) {
            playBtns[i].addEventListener('click', function(e) {
                // Hide the overlay and play button
                playBtns[i].parentElement.classList.add('vidPlay');

                // Play the video
                // This pause is equal to the animation duration on the overlay and play buttons, so the video doesn't start
                // until the overlay is completely out of the way
                setTimeout(function() {
                    videos[i].setAttribute('controls', 'true');
                    videos[i].play();   
                }, 500);
            })
        }
    }

    // Blog single gallery functionality

    if (document.querySelector('body.blog-single')) {
        let gallery = document.querySelector('.gallery .img-wrapper');
        let dist = gallery.children[1].getBoundingClientRect().width;
        dist = (window.innerWidth < 992) ? dist + ((window.innerWidth - 66) / 12) : dist + 30;
        let startTouch;
        let position = 0;
        let flag = false;
        let mouse = false;
        let prevMobile = (window.innerWidth > 992) ? false : true;
        let min = 0;
        let max = (window.innerWidth < 992) ? gallery.childElementCount - 1 : gallery.childElementCount - 3;

        window.addEventListener('resize', function() {
            if (prevMobile && window.innerWidth > 992) { position = (position == 0) ? 0 : position - 1; prevMobile = !prevMobile; }
            else if (!prevMobile && window.innerWidth < 992) { position++; prevMobile = !prevMobile; }

            dist = gallery.children[1].getBoundingClientRect().width;
            dist = (window.innerWidth < 992) ? dist + ((window.innerWidth - 66) / 12) : dist + 30;
            max = (window.innerWidth < 992) ? gallery.childElementCount - 1 : gallery.childElementCount - 3;
            gallery.style.transform = `translate(-${position * dist}px, 0)`;
        })

        var touchStart = function(e) {
            startTouch = e.touches[0].screenX;
            flag = true;
        }

        var clickStart = function(e) {
            startTouch = e.clientX;
            flag = true;
            mouse = true;
        }

        var clickEnd = function(e) {
            flag = true;
            mouse = false;
        }

        var swipeMove = function(e, swipe) {
            if (swipe < -50 && flag && position < max) {
                // Swipe left
                position++;
                gallery.style.transform = `translate(-${position * dist}px, 0)`;
                flag = false;
            }
            else if (swipe > 50 && flag && position > min) {
                // Swipe right
                position--;
                gallery.style.transform = `translate(-${position * dist}px, 0)`;
                flag = false;
            }
        }

        gallery.addEventListener('touchstart', touchStart);
        gallery.addEventListener('mousedown', clickStart);

        gallery.addEventListener('touchmove', function(e) {
            let swipe = e.touches[0].screenX - startTouch;
            swipeMove(e, swipe);
        });
        gallery.addEventListener('mousemove', function(e) {
            if (mouse) {
                let swipe = e.clientX - startTouch;
                swipeMove(e, swipe);
            }
        });

        gallery.addEventListener('mouseup', clickEnd);
    }

    // FAQ answer animation

    let questions = document.querySelectorAll('body.faq .question-answer');
    let answers = document.querySelectorAll('body.faq .answer');
    let openFlag = false;
    for (let i = 0 ; i < questions.length ; i++) {
        let height = answers[i].getBoundingClientRect().height;
        answers[i].setAttribute('style', `--tooltip-height: ${height}px`);

        questions[i].addEventListener('click', function(e) {
            if (!openFlag) {
                for (let j = 0 ; j < questions.length ; j++) {
                    if (questions[j] != e.currentTarget) {
                        questions[j].classList.remove('active');
                        questions[j].classList.add("grey");
                        questions[j].querySelector('animate#backward').beginElement();
                    }
                }
                openFlag = true;
            }
            else {
                let prevActive = document.querySelector('.question-answer.active');
                if (prevActive) {
                    prevActive.classList.toggle('active');
                    prevActive.classList.add("grey");
                    prevActive.querySelector('animate#backward').beginElement();
                    if (questions[i] != prevActive) {
                        questions[i].classList.toggle('active');
                        questions[i].classList.remove("grey");
                        questions[i].querySelector('animate#forward').beginElement();
                    }
                }
                else {
                    questions[i].classList.toggle('active');
                    questions[i].classList.remove("grey");
                    questions[i].querySelector('animate#forward').beginElement();
                }
            }
        })
    }

    // Put SVG code into the document where needed
    function loadSVG(file, destination)
    {
        var SVGFile = file;
        var loadXML = new XMLHttpRequest;
        function handler(){
            if(loadXML.readyState == 4 && loadXML.status == 200)
            {
                destination.innerHTML = loadXML.responseText;
            }
        }
        if (loadXML != null){
            loadXML.open("GET", SVGFile, true);
            loadXML.onreadystatechange = handler;
            loadXML.send();
        }
    }

    if (document.querySelector('body.product')) {
        let svg_icons = document.querySelectorAll('.icons .illustration');
        for (let i = 0 ; i < svg_icons.length ; i++) {
            let file = svg_icons[i].classList[1];
            loadSVG(file, svg_icons[i]);
        }
    }

    if (document.querySelector('body.index')) {
        let svg_icons = document.querySelectorAll('.img.illustration');
        for (let i = 0 ; i < svg_icons.length ; i++) {
            let file = svg_icons[i].classList[2];
            loadSVG(file, svg_icons[i]);
        }
    }

    if (document.querySelector('.dot-wrapper')) {
        let dots = document.querySelectorAll('.dot-wrapper');
        for (let i = 0 ; i < dots.length ; i++) {
            dots[i].addEventListener('mouseenter', function() {
                dots[i].parentElement.classList.add('active');
            })
            dots[i].parentElement.addEventListener('mouseleave', function() {
                dots[i].parentElement.classList.remove('active');
                setTimeout(function() {
                    dots[i].parentElement.classList.remove('active-still');
                }, 2000);
            })
        }
    }

    if (document.querySelector('.dot')) {
        let dots = document.querySelectorAll('.dot');
        let matrix = [];
        let temp = [];

        for (let i = 0 ; i < dots.length ; i++) {
            temp = [];
            // dot, flag, dotflag, popupflag
            temp = [dots[i], false, false, false];
            matrix.push(temp);
        }

        for (let i = 0 ; i < matrix.length ; i++) {
            matrix[i][0].parentElement.parentElement.parentElement.addEventListener('mouseenter', function(e) {
                matrix[i][1] = false;
                e.currentTarget.classList.add('hovering');
            })
            matrix[i][0].parentElement.parentElement.parentElement.addEventListener('mouseleave', function(e) {
                matrix[i][1] = true;
                matrix[i][0].parentElement.classList.remove('active');
            })
            matrix[i][0].parentElement.parentElement.addEventListener('mouseenter', function(e) {
                matrix[i][3] = true;
            })
            matrix[i][0].parentElement.parentElement.addEventListener('mouseleave', function(e) {
                matrix[i][0].parentElement.classList.remove('active');
                if (!matrix[i][1] && !matrix[i][2]) {
                    e.currentTarget.parentElement.classList.add('hovering');
                }
                matrix[i][3] = false;
            })
            matrix[i][0].parentElement.addEventListener('mouseenter', function(e) {
                matrix[i][2] = true;
            })
            matrix[i][0].parentElement.addEventListener('mouseleave', function(e) {
                if (!matrix[i][3]) {
                    e.currentTarget.classList.remove('active');
                }
                matrix[i][2] = false;
            })
            matrix[i][0].addEventListener('animationiteration', function(e) {
                if (matrix[i][1]) {
                    matrix[i][1] = false;
                    e.currentTarget.parentElement.parentElement.parentElement.classList.remove('hovering');
                }
                if ((e.currentTarget.parentElement.parentElement.classList.contains('active')) && (matrix[i][2] || matrix[i][3])) {
                    matrix[i][2] = false;
                    e.currentTarget.parentElement.parentElement.parentElement.classList.remove('hovering');
                    e.currentTarget.parentElement.classList.add('active');
                }
            })
        }
    }

});